<template>
  <CModal :show.sync="show" :title="$pgettext('event.modal.pay_as_you_go.title', 'Publish')" centered>
    <PComponentLoader :loading="loading">
      <template v-if="!loading">
        <template v-if="unlockInfo.status === unlockStatus.already_unlocked">
          <div v-translate translate-context="event.modal.pay_as_you_go.content">
            You have already unlocked all the media you can.
          </div>
        </template>
        <template v-if="unlockInfo.status === unlockStatus.nothing_to_pay">
          <translate translate-context="event.modal.pay_as_you_go.content"
                     :translate-params="{limit: unlockInfo.limit, uploaded: unlockInfo.uploaded}">
            The upload limit is %{limit}. You have uploaded %{uploaded} media files.<br>
            You don't need to pay to unlock more media files.
          </translate>
        </template>
        <template v-if="unlockInfo.status === unlockStatus.pay_to_unlock">
          <translate translate-context="event.modal.pay_as_you_go.content"
                     :translate-params="{limit: unlockInfo.limit, uploaded: unlockInfo.uploaded}">
            The upload limit is %{limit}. You have uploaded %{uploaded} media files.<br>
          </translate>
          You have {{ unlockInfo.to_pay }} media files to unlock.
          Te price is {{ unlockInfo.price }} {{paymentCurrency}}.
        </template>
      </template>
    </PComponentLoader>
    <template #footer>
      <CButton color="secondary" size="sm" @click="show = false" v-translate>Close</CButton>
      <PButton
          color="primary" v-translate translate-context="event.modal.publish.actions" class="mr-3"
          v-if="requirePayment"
          @click="onPayment">
        Go to Payment
      </PButton>
    </template>
  </CModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PButton from "@/components/PButton.vue";
import unlockStatus from "@/domain/core/constant/unlockStatus";
import PComponentLoader from "@/domain/core/components/PComponentLoader.vue";

export default {
  name: "PayAsYouGoModal",
  components: {
    PComponentLoader,
    PButton,
  },
  data() {
    return {
      show: false,
      loading: true,
      planOptionId: null,
    }
  },
  computed: {
    ...mapGetters('eventWizard', [
      'unlockInfo',
      'paymentCurrency'
    ]),
    requirePayment() {
      if (!this.unlockInfo) return false
      return unlockStatus.isPayable(this.unlockInfo.status)
    },
    unlockStatus() {
      return unlockStatus
    },
  },
  methods: {
    ...mapActions('eventWizard', [
      'fetchUnlockInfo',
      'fetchPaymentCurrency',
    ]),
    async open() {
      this.show = true
      this.loading = true
      await this.fetchUnlockInfo()
      await this.fetchPaymentCurrency()
      this.loading = false
    },
    async onPayment() {
      await this.notifySuccess(this.$pgettext('event.modal.pay_as_you_go', 'Media Unlocked'))
      this.show = false

    },

  }
}
</script>